export default "__VITE_ASSET__CP0OKlgP__"